import { useState, useEffect } from 'react';
import { getMovieBySlug } from '../utils/sanityClient';
import { SanityImage } from '../types/movie';

interface MovieDetails {
  _id: string;
  title: string;
  releaseDate: string;
  hypeLevel: number;
  poster: any;
  posterCopyright: string;
  synopsis: string;
  synopsisCopyright?: string;
  slug: string;
  director: {
    _id: string;
    name: string;
    image?: SanityImage;
    imdbId?: string;
  };
  directors: Array<{
    _id: string;
    name: string;
    image?: SanityImage;
    imdbId?: string;
  }>;
  mainActors: Array<{
    _id: string;
    name: string;
    image?: SanityImage;
  }>;
  trailers: Array<{
    _id: string;
    title: string;
    videoUrl: string;
    platform: 'youtube' | 'vimeo';
    isMainTrailer: boolean;
  }>;
}

export function useMovieDetails(slug: string) {
  const [movie, setMovie] = useState<MovieDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchMovie() {
      try {
        setLoading(true);
        setError(null);
        const data = await getMovieBySlug(slug);
        setMovie(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch movie details'));
      } finally {
        setLoading(false);
      }
    }

    if (slug) {
      fetchMovie();
    }
  }, [slug]);

  return { movie, loading, error };
}